// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"541":"8c5a9f00","912":"f8e7bfc2"}[chunkId] + ".chunk.css";
};